export default "<div class=\"group\" [ngStyle]=\"{ 'justify-content':  alignment }\">\n  <ng-content></ng-content>\n</div>\n";